import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-thanks',
  templateUrl: './thanks.component.html',
  styleUrls: ['./thanks.component.scss']
})
export class ThanksComponent implements OnInit, OnDestroy {

  id: string;
  heading = 'Thank You for filling out a request form';
  subheading = 'We look forward to speaking with you soon.';
  isApplicationThanks = false;
  private queryParamsSubscription: Subscription;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,    ) { }

  ngOnInit() {
    window.scrollTo(0,0);

    this.queryParamsSubscription = this.activatedRoute.queryParamMap.subscribe((params) => {
      this.id = params.get('id') || '';
      this.isApplicationThanks = ['retail-stores', 'marketplace', 'influencers'].indexOf(this.id) !== -1;

      if (this.isApplicationThanks) {
        const accountName =
          params.get('accountName') ||
          params.get('storeName') ||
          params.get('companyName') ||
          params.get('organizationName');
        const accountLabel = accountName && accountName.trim() ? accountName.trim() : 'your';

        this.heading = 'Thank You for Applying to Join the MarkitPlace Network';
        this.subheading = `We've received your application and will review it within 48 hours. If approved, you'll receive access to your MarkitPlace Admin Portal, where you can set up ${accountLabel} account and get started.`;
        return;
      }

      this.heading = 'Thank You for filling out a request form';
      this.subheading = 'We look forward to speaking with you soon.';
    });
  }

  ngOnDestroy() {
    if (this.queryParamsSubscription) {
      this.queryParamsSubscription.unsubscribe();
    }
  }

 }
